import React, { useState } from "react";
import Navbar from '../Components/Navbar'
import img from '../Assets/about.png'
import img2 from '../Assets/Rectangle 42.png'
import icon from '../Assets/icons (1).png'
import img3 from '../Assets/newpy.png'
// import newicon from '../Assets/67175a5cecf4084f2b6107ea_award-logo-02 1.png'
import Footer from '../Components/Footer'
import g1 from "../Assets/g1.jpeg";
import g2 from "../Assets/g2.jpeg";
import g3 from "../Assets/g3.jpeg";
import g4 from "../Assets/g4.jpeg";
import g5 from "../Assets/g5.jpeg";
import g6 from "../Assets/g6.jpeg";
import g7 from "../Assets/g7.jpeg";
import g8 from "../Assets/g8.jpeg";
import g9 from "../Assets/g9.jpeg";
import g10 from "../Assets/g10.jpeg";
import g11 from "../Assets/g11.jpeg";
import g12 from "../Assets/g12.jpeg";
import g13 from "../Assets/g13.jpeg";
import g14 from "../Assets/g14.jpeg";
import g15 from "../Assets/g15.jpeg";
import g16 from "../Assets/g16.jpeg";
import g17 from "../Assets/g17.jpeg";
import g18 from "../Assets/g18.jpeg";
import g19 from "../Assets/g19.jpeg";
// import g20 from "../Assets/g20.jpeg";
import g21 from "../Assets/g21.jpeg";
import g22 from "../Assets/g22.jpeg";
import g23 from "../Assets/g23.jpeg";
import g24 from "../Assets/g24.jpeg";
import g25 from "../Assets/g25.jpeg";
import g26 from "../Assets/g26.jpeg";
import g27 from "../Assets/g27.jpeg";
import g28 from "../Assets/g28.jpeg"; 
import { Helmet } from "react-helmet";
import emailjs from "@emailjs/browser";

const images = [
  g1,g2,g3,g4,g5,g6,g7,g8,g9,g10,
  g11,g12,g13,g14,g15,g16,g17,g18,
  g19,g21,g22,g23,g24,g25,g26,g27,g28
];
const hospitalSchedule = {
  "Aadhya 9 Hospital, Shadipur": {
    days: ["Monday","Wednesday","Thursday","Saturday","Sunday"],
    time: "5:00 PM - 7:00 PM"
  },
  "Apollo Cradle, Moti Nagar": {
    days: ["Tuesday","Friday"],
    time: "5:00 PM - 7:00 PM"
  },
  "Kailash IVF, Noida": {
    days: ["Monday","Tuesday","Wednesday","Friday","Saturday","Sunday"],
    time: "9:00 AM - 1:00 PM"
  }
};


function About() {
  const [hospital,setHospital] = useState("");
    const [date,setDate] = useState("");
    const [time,setTime] = useState("");
  
    const [name,setName] = useState("");
    const [phone,setPhone] = useState("");
    const [email,setEmail] = useState("");
  const firstRow = images.slice(0, Math.ceil(images.length / 2));
  const secondRow = images.slice(Math.ceil(images.length / 2));
  
    const handleDate = (value) => {
  
      const selectedDate = new Date(value);
      const day = selectedDate.toLocaleString("en-US",{weekday:"long"});
  
      if(hospitalSchedule[hospital]?.days.includes(day)){
        setDate(value);
        setTime(hospitalSchedule[hospital].time);
      }
      else{
        alert("Doctor not available on this day");
        setDate("");
        setTime("");
      }
  
    }
  
const sendWhatsapp = async () => {

  if(!name || !phone || !email || !hospital || !date){
    alert("Please fill all required fields including email");
    return;
  }

  const templateParams = {
    name,
    phone,
    email,
    hospital,
    date,
    time
  };

  const message = `Appointment Booking

Name: ${name}
Phone: ${phone}
Hospital: ${hospital}
Date: ${date}
Time: ${time}
Email: ${email}
`;

  const whatsappUrl = `https://wa.me/917703895964?text=${encodeURIComponent(message)}`;

  try {

    await emailjs.send(
      "service_n802jco",
      "template_g6paq09",
      templateParams,
      "yClAt8VCazgj2VJJ7"
    );

    console.log("Admin mail sent");

    await emailjs.send(
      "service_n802jco",
      "template_2i7nheg",
      templateParams,
      "yClAt8VCazgj2VJJ7"
    );

    console.log("User mail sent");

    alert("Appointment booked successfully!");

    // IMPORTANT CHANGE
    window.location.href = whatsappUrl;

    setName("");
    setPhone("");
    setEmail("");
    setHospital("");
    setDate("");
    setTime("");

  } catch (err) {
    console.log("ERROR:", err);
    alert("Something went wrong! Check console.");
  }

};
  
  return (
    <div>
      <Helmet>
  <title>About Dr. Monika Gupta | IVF Specialist in Delhi | 15+ Years Experience</title>

  <meta
    name="description"
    content="Learn about Dr. Monika Gupta, experienced IVF & fertility specialist in Delhi with 15+ years expertise. Worked at Indira IVF Patel Nagar for 6 years. Expert in IVF, IUI, ICSI & women’s healthcare."
  />

  <meta
    name="keywords"
    content="Dr Monika Gupta IVF, IVF specialist Delhi, fertility doctor Delhi, gynecologist Delhi, infertility expert Delhi, Indira IVF Patel Nagar doctor, IVF expert profile"
  />

  <meta property="og:title" content="About Dr. Monika Gupta | IVF Specialist Delhi" />
  <meta property="og:description" content="15+ years experienced IVF specialist with expertise in fertility & women healthcare." />
  <meta property="og:type" content="profile" />
</Helmet>
        <Navbar/>
       <div className='banner-page'>
        <h3>About Me</h3>

        <p>Home-About Us</p>

        </div>
       {/* <div className='about-div'>
  <div className='about-div-left'>
    <h3>Dr. Monika Gupta</h3>
    <img src={img}/>
  </div>

  <div className='about-div-right'>
    <h3>Expert Fertility & Women’s Care with a Personal Touch</h3>
    <p>
      Dr. Monika Gupta is a Senior IVF & Fertility Specialist, Obstetrician and Gynaecologist with over 14 years of experience in reproductive medicine and women’s healthcare. Currently practicing as an IVF Specialist at Aadhya 9 Hospital, Shadipur, Dr. Gupta has also served at Indira IVF (6 years) and Akanksha IVF (3 years), gaining extensive expertise in advanced fertility treatments.
    </p>
    <p>
      Specializing in IVF, IUI, egg freezing, blastocyst culture, high-risk pregnancy management, and minimally invasive gynecological procedures, Dr. Gupta is known for a transparent, ethical, and patient-focused approach. Combining modern reproductive technology with compassionate care, the goal is to provide safe, effective, and personalized treatment for every couple and woman seeking fertility and maternity support.
    </p>
  </div>
</div> */}


<div className="about-section-new">
  <div className="about-container-new">

    {/* LEFT SIDE */}
    <div className="about-profile-new">
      <div className="about-image-wrapper">
        <img src={img} alt="Dr. Monika Gupta" />
      </div><br/>
      <br/>

      <div className="about-name-box">
        <h2>Dr. Monika Gupta</h2>
        <span>Senior IVF & Fertility Specialist</span>
      </div>
    </div>

    {/* RIGHT SIDE */}
    <div className="about-content-new">
      <h3 className="about-heading-new">
Expert Fertility & Women’s Care with a Personal Touch
      </h3>

      <p>
     Dr. Monika Gupta is a Senior Fertility Specialist, Obstetrician & Gynaecologist with over 15 years of experience in reproductive medicine and women’s healthcare.
       </p>
<p>
  I am currently practicing as a Fertility Specialist at Aadhya 9 Hospital, Shadipur, and have previously worked with Indira IVF and Akanksha IVF, gaining extensive expertise in advanced fertility treatments and helping create over 5000+ happy couples.
</p>
      <p>
      I specialize in IVF, IUI, egg freezing, blastocyst culture, high-risk pregnancy management, and minimally invasive gynecological procedures. With a transparent, ethical, and patient-focused approach, my mission is to provide safe, effective, and personalized fertility and maternity care.
      </p>
    </div>

  </div>
</div>
        {/* <div className='qualification'>

            <div className='qualification-div'>
   <div className='qualification-div-left'>
    <div className='qualification-div-left-box1'>
    <div className='qualification-div-left-boxa'>
<h3>M.B.B.S</h3>
    </div>
     <div className='qualification-div-left-boxa'>
<h3>MS (Obstetrics & Gynaecology)</h3>
    </div>
    </div>
      <div className='qualification-div-left-box2'>
    <div className='qualification-div-left-boxa'>
<h3>Fellowship in IVF & Reproductive Medicine</h3>
    </div>
  
    </div>

        </div>
           <div className='qualification-div-right'>
<img src={img2}/>
        </div>
        </div>

        </div> */}

<div className="mv-section">
  <div className="mv-container">

    <div className="mv-header">
      <p className="mv-subtitle">Our Commitment</p>
      <h2>Mission & Vision</h2>
    </div>

    <div className="mv-grid">

      <div className="mv-card mission-card">
        {/* <div className="mv-icon"><i class="bi bi-bullseye"></i></div> */}
        <h3>Our Mission</h3>
        <p>
To provide safe, ethical, and advanced fertility and women’s healthcare through personalized treatment plans, modern reproductive technology, and dedicated support for every patient.
        </p>
      </div>

      <div className="mv-card vision-card">
        {/* <div className="mv-icon"><i class="bi bi-eye-fill"></i></div> */}
        <h3>Our Vision</h3>
        <p>
          To become a trusted center of excellence in reproductive medicine and 
          women’s wellness, empowering families with hope, confidence, and 
          world-class fertility solutions.
        </p>
      </div>

    </div>

  </div>
</div>

 <section className="cs-section">
      <div className="cs-container">

        {/* LEFT */}
        <div className="cs-left">
          <h2>
            Get in touch with our <br /> expert today!
          </h2>
        </div>

        {/* RIGHT */}
        <div className="cs-right">

          {/* CALL */}
          <div className="cs-box">
            <div className="cs-icon">
              <i className="bi bi-telephone-fill"></i>
            </div>
            <div>
              <p className="cs-label">Call Us</p>
              <a href="tel:+917703895964" className="cs-text">
                +91 7703895964
              </a>
            </div>
          </div>

          {/* EMAIL */}
          <div className="cs-box">
            <div className="cs-icon">
              <i className="bi bi-envelope-fill"></i>
            </div>
            <div>
              <p className="cs-label">Email Us</p>
              <a href="mailto:drmonicaivf@gmail.com" className="cs-text">
                drmonicaivf@gmail.com
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>

<div className="qualification-section">
  <div className="qualification-container">

    <div className="qualification-left">
      <p className="qualification-subtitle">Professional Excellence</p>
      <h2 className="qualification-title">Qualifications & Expertise</h2>

      <div className="qualification-grid">
        <div className="qualification-card">
          <h3>M.B.B.S</h3>
        </div>

        <div className="qualification-card">
          <h3>MS (Obstetrics & Gynaecology)</h3>
        </div>

        <div className="qualification-card full-width">
          <h3>Fellowship in IVF & Reproductive Medicine</h3>
        </div>
      </div>
    </div>

    <div className="qualification-right">
      <img src={g13} alt="Doctor Qualification" />
    </div>

  </div>
</div>
          {/* <div className='happyclient-div'>
    <div className='happyclient'>
     <div className='happyclient-box'>
     <img src={icon}/>
     <h3>5000 +</h3>
     <p>Happy Couples</p>

    </div>
        <div className='happyclient-box'>
     <img src={icon}/>
     <h3>5000 +</h3>
     <p>Happy Couples</p>

    </div>
        <div className='happyclient-box'>
     <img src={icon}/>
     <h3>5000 +</h3>
     <p>Happy Couples</p>

    </div>
        <div className='happyclient-box'>
     <img src={icon}/>
     <h3>5000 +</h3>
     <p>Happy Couples</p>

    </div>

        </div>
        </div> */}
        <div className='philosophy'>
     <div className='philosophy-left'>
      <img src={img3} alt="" />

        </div>
             <div className='philosophy-right'>
              <h3>Our Philosophy Of Care</h3>
              <p>
                
Dr. Monika Gupta’s philosophy of care is rooted in compassion, transparency, and clinical excellence. She understands that the journey to parenthood can be emotionally and physically challenging, which is why she focuses on creating personalized treatment plans tailored to each couple’s unique needs.
<br/>
By combining advanced reproductive technologies with ethical medical practices and empathetic guidance, Dr. Monika Gupta strives to provide a supportive and nurturing environment where patients feel heard, respected, and confidently guided at every step of their fertility journey.
<br/>Her goal is to ensure that every patient receives safe and effective fertility and women’s healthcare, from the first consultation to successful treatment and beyond.
              </p>
        </div>
        </div>

  <section className="glxp-section">
      <div className="glxp-container">

        {/* HEADER */}
        <div className="glxp-header">
          <span>Our Gallery</span>
          <h2>Moments of Care & Happiness</h2>
        </div>

        {/* MASONRY GRID */}
        <div className="glxp-grid">
          {images.map((img, i) => (
            <div className="glxp-item" key={i}>
              <img src={img} alt="gallery" />
            </div>
          ))}
        </div>

      </div>
    </section>

        {/* <div className='award'>
          <h3>Awards & certifications</h3>

          <div className='award-div'>
 <div className='award-box'>
  <img src={newicon} alt="" />
  <h3>Medical award 2018</h3>

          </div>
          <div className='award-box'>
  <img src={newicon} alt="" />
  <h3>Medical award 2018</h3>

          </div>
          <div className='award-box'>
  <img src={newicon} alt="" />
  <h3>Medical award 2018</h3>

          </div>
          <div className='award-box'>
  <img src={newicon} alt="" />
  <h3>Medical award 2018</h3>

          </div>
          </div>

        </div> */}
<div className="client-timing" id="booking">
  <div className="client-timing-left" >
<div className="client-timing-left-form">

<h4>Make an appointment</h4>

<div className="ips">
<div className="ip">
<label>Full Name</label>
<input type="text" value={name} onChange={(e)=>setName(e.target.value)}/>
</div>

<div className="ip">
<label>Phone</label>
<input type="text" value={phone} onChange={(e)=>setPhone(e.target.value)}/>
</div>
</div>

<div className="ips">
<div className="ip">
<label>Select Hospital</label>

<select
value={hospital}
onChange={(e)=>setHospital(e.target.value)}
>
<option value="">Select Hospital</option>
<option>Aadhya 9 Hospital, Shadipur</option>
<option>Apollo Cradle, Moti Nagar</option>
<option>Kailash IVF, Noida</option>
</select>

</div>

<div className="ip">
<label>Select Date</label>

<input
type="date"
min={new Date().toISOString().split("T")[0]}
value={date}
onChange={(e)=>handleDate(e.target.value)}
/>

</div>
</div>

<div className="ips">

<div className="ip">
<label>Available Time</label>

<input
type="text"
value={time}
readOnly
/>
</div>

<div className="ip">
<label>Email</label>
<input type="email" value={email} onChange={(e)=>setEmail(e.target.value)}/>
</div>

</div>

<button onClick={sendWhatsapp}>
Book an appointment
</button>

</div>
    </div>
</div>
        <Footer/>
    </div>
  )
}

export default About
